import { Box, Divider, Typography } from '@mui/material';

import { FactsheetDetails } from '@/pages/Facthsheets/constants';

const ApproachTab = ({ factsheet }: { factsheet: FactsheetDetails }) => {
  let approachParsedLines: string[] = [];
  if (
    factsheet.factsheetVersionHistory.length > 0 &&
    factsheet.factsheetVersionHistory[0].calculationApproach
  ) {
    approachParsedLines = factsheet.factsheetVersionHistory[0]?.calculationApproach?.split('\n');
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
      <Box
        display='flex'
        sx={{ minWidth: '50%', maxWidth: '50%', flexDirection: 'column', pl: 1, pr: 2 }}
      >
        <Box
          display='flex'
          sx={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            py: 0.5
          }}
        >
          <Typography
            sx={{ fontWeight: 700 }}
            variant='body2'
          >
            Trade Data Approach
          </Typography>
          <Typography
            sx={{ fontWeight: 700 }}
            variant='body2'
          >
            Y/N
          </Typography>
        </Box>
        <Divider sx={{ backgroundColor: 'text.primary', pr: 4 }} />
        <Box
          display='flex'
          sx={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            pt: 0.5
          }}
        >
          <Typography>Priority to reported and concluded transactions</Typography>
          <Typography>{factsheet.priorityToTransactions ? 'Y' : 'N'}</Typography>
        </Box>
        <Box
          display='flex'
          sx={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            pt: 0.5
          }}
        >
          <Typography>Sole-sourced data from trading principals accepted</Typography>
          <Typography>{factsheet.soleSourcedDataAccepted ? 'Y' : 'N'}</Typography>
        </Box>
        <Box
          display='flex'
          sx={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            pt: 0.5
          }}
        >
          <Typography>Inter-affiliate data accepted as valid</Typography>
          <Typography>{factsheet.interAffiliateDataAccepted ? 'Y' : 'N'}</Typography>
        </Box>
      </Box>
      <Box
        display='flex'
        sx={{ flexDirection: 'column', pr: 1, pl: 2 }}
      >
        {approachParsedLines.map(line => {
          return (
            <Typography
              key={line}
              sx={{
                fontSize: 16,
                fontWeight: 500,
                mb: 0.5
              }}
            >
              {line}
            </Typography>
          );
        })}
      </Box>
    </Box>
  );
};
export default ApproachTab;
